export default __webpack_public_path__ + "static/media/bizcovery_pvt_ltd_annual_return_fy_23-24.2c103230.pdf";